import Collapsible from 'react-collapse';

export default Collapsible;
